import React from 'react';

import useTranslate from '@src/i18n/useTranslate';
import useCurrencyFormat from '@src/hooks/useCurrencyFormat';
import { Total, PurchaseResume } from './styles';
import { DirectLink } from '@src/core/buyerApiClient';
import CurrencySelector from '../CurrencySelector';
import CurrencyWarning from '../CurrencyWarning';

interface DrawerProps {
  directLink: DirectLink;
  showTotal?: boolean;
}

export const PaymentSummary = (props: DrawerProps) => {
  const { directLink, showTotal = false } = props;

  const { i18n } = useTranslate();
  const { formatCurrencyInfo } = useCurrencyFormat();

  return (
    <>
      <CurrencySelector />
      <CurrencyWarning />
      <PurchaseResume>
        {showTotal ? (
          <Total>
            <p>{i18n('direct_link_summary_total')}</p>
            <p>{formatCurrencyInfo(directLink.totalAmountCurrencyInfo)}</p>
          </Total>
        ) : null}
      </PurchaseResume>
    </>
  );
};

export default PaymentSummary;
